var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.992 16.003L12 7.828l1.26 8.175h4.732zM6.262-.003L12 7.827l-1.207-7.83h-4.53zm4.478 16.006L12 7.828l-5.992 8.175h4.732zM0-.003v5.986l12 1.845L1.328-.003H0zm0 16.006h.855L12 7.828 0 9.671v6.33zm12-8.175l12-1.846V-.003h-1.328L12 7.827zm1.207-7.83L12 7.827l5.738-7.83h-4.53zM24 16.003v-6.33L12 7.828l11.145 8.175H24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 10.61a2.783 2.783 0 100-5.565 2.783 2.783 0 000 5.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 9.912a2.085 2.085 0 100-4.17 2.085 2.085 0 000 4.17z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/mk.3b13e016b696f7a6ffb1bb60e2781f47.svg";
export { ForwardRef as ReactComponent };